<script setup lang="ts">
import { ref, watch, computed } from "vue";
import { storeToRefs } from "pinia";
import { useMemberService } from "@/stores/memberFunction/memberService";
import { useLogin } from "@/stores/login";
import triangle_icon from "@image/memberFunction/common/triangle_icon.png";
import 文字框_長_A from "@image/memberFunction/文字框/文字框_長_A.png";
import 驚嘆號icon from "@image/memberFunction/11/驚嘆號icon.png";

interface OnlineDepositFormData {
  sPay_name: string;
  other: string;
  payCount: number;
  CVS: string | undefined;
  StorePayment: string | undefined;
  BarcodePayment: string | undefined;
  TelecomPayment: string | undefined;
}
interface OnlineDepositPostData {
  nId: string;
  sPay_name: string;
  sNickname: string;
  nMax: string;
  nMin: string;
  sGids: string;
  sPayType: string;
  nMoney: string;
  t: string;
  a: string;
  CVS: string | undefined;
  StorePayment: string | undefined;
  BarcodePayment: string | undefined;
  TelecomPayment: string | undefined;
}
const memberService = useMemberService();
const login = useLogin();
const { MemberRechargeList } = storeToRefs(memberService);
const { memberData } = storeToRefs(login);

const OnlineDepositForm = ref<any>(null);

// 充值平審核
// const payNameId = ref<string>("");
const payNameId = computed(() => {
  const ListAry = Object.values(MemberRechargeList.value);
  return ListAry[0].nId;
});

// 充值方式
const payOther = ref<string>("");

// 充值方式列表
const PayType = computed(() => {
  if (!payNameId.value) return {};
  const nowPay = Object.values(MemberRechargeList.value).find((item) => {
    return item.nId === payNameId.value;
  });
  if (!nowPay) return {};
  if (!nowPay.sPayType) return {};
  return nowPay.sPayType.other;
});

// 支付渠道 若 payOther 是 StorePayment
const PayStorePayment = computed(() => {
  if (payOther.value !== "StorePayment") return {};
  const nowPay = Object.values(MemberRechargeList.value).find((item) => {
    return item.nId === payNameId.value;
  });
  if (!nowPay) return {};
  if (!nowPay.sPayType) return {};

  return nowPay.sPayType.StorePayment;
});

// 支付渠道 若 payOther 是 CVS
const PayCVS = computed(() => {
  if (payOther.value !== "CVS") return {};
  const nowPay = Object.values(MemberRechargeList.value).find((item) => {
    return item.nId === payNameId.value;
  });
  if (!nowPay) return {};
  if (!nowPay.sPayType) return {};

  return nowPay.sPayType.CVS;
});

// 條碼渠道 若 payOther 是 BarcodePayment
const PayBarcodePayment = computed(() => {
  if (payOther.value !== "BarcodePayment") return {};
  const nowPay = Object.values(MemberRechargeList.value).find((item) => {
    return item.nId === payNameId.value;
  });
  if (!nowPay) return {};
  if (!nowPay.sPayType) return {};
  return nowPay.sPayType.BarcodePayment;
});

// 電信渠道 若 payOther 是 TelecomPayment
const PayTelecomPayment = computed(() => {
  if (payOther.value !== "TelecomPayment") return {};
  const nowPay = Object.values(MemberRechargeList.value).find((item) => {
    return item.nId === payNameId.value;
  });
  if (!nowPay) return {};
  if (!nowPay.sPayType) return {};
  return nowPay.sPayType.TelecomPayment;
});
watch(payNameId, () => {
  payOther.value = "";
});

function submit(VForm: OnlineDepositFormData) {
  const findRechargeList = Object.values(MemberRechargeList.value).find(
    (item) => {
      return item.nId === payNameId.value;
    }
  );

  if (!findRechargeList) return;
  const { nId, sPay_name, sNickname, nMax, nMin, sGids, t, a } =
    findRechargeList;
  const { payCount, StorePayment, CVS, BarcodePayment, TelecomPayment } = VForm;

  const postData: OnlineDepositPostData = {
    nId,
    sPay_name,
    sNickname,
    nMax,
    nMin,
    sGids,
    t: t.toString(),
    a,
    sPayType: payOther.value,
    nMoney: payCount.toString(),
    CVS,
    StorePayment,
    BarcodePayment,
    TelecomPayment,
  };
  OnlineDepositForm.value.resetForm();
  memberService.getMemberRecharge(postData);
}
</script>

<template>
  <VForm @submit="submit" ref="OnlineDepositForm" class="py-[2em] px-[9vw]">
    <div class="text-primary">
      <label
        for="cardNumber"
        class="items-center justify-between text-[14px] md:text-[16px] hidden">
        <p class="mr-[1em] text-primary">
          {{ $t("MemberFunction.Deposit.RechargeReview") }}
        </p>
        <div class="relative inline-block">
          <div class="h-[26px] w-full"></div>
          <img
            v-img-src="triangle_icon"
            alt=""
            class="absolute top-0 right-0 pointer-events-none h-[26px] z-20" />
          <VField
            id="sPay_name"
            :label="$t('MemberFunction.Deposit.RechargeReview')"
            name="sPay_name"
            v-slot="{ field }"
            v-model="payNameId"
            class="relative">
            <select
              v-bind="field"
              class="absolute select-bg-border top-0 bg-transparent px-2 rounded w-full h-[26px] text-primary">
              <!-- <option class="text-black" value="">請選擇充值平審核</option> -->
              <option
                class="text-black"
                :value="item.nId"
                v-for="(item, key, index) in MemberRechargeList"
                :key="item.nId + 'onlineDepositPayName'"
                selected>
                {{ item.sPay_name + index }}
              </option>
            </select>
          </VField>

          <!-- <ErrorMessage
            name="ActGame"
            class="text-primary text-[14px] text-center"
          /> -->
        </div>
      </label>
      <label
        for="other"
        class="grid grid-cols-12 text-[14px] md:text-[16px] mt-[12px] md:mt-[3dvh]">
        <p class="mr-[1em] text-primary col-span-4">
          {{ $t("MemberFunction.Deposit.DepositMethod") }}
        </p>

        <div class="relative col-span-8">
          <div class="h-[26px] w-full">
            <img
              v-img-src="triangle_icon"
              alt=""
              class="h-[12px] absolute right-[2.5%] md:right-[3.4%] top-[13px] -translate-y-1/2 z-20" />
          </div>
          <VField
            id="other"
            :label="$t('MemberFunction.Deposit.DepositMethod')"
            name="other"
            v-slot="{ field }"
            v-model="payOther"
            class="relative w-full">
            <select
              v-bind="field"
              class="absolute select-bg-border top-0 bg-transparent px-2 rounded w-full h-[26px] text-primary">
              <option class="text-black" value="">
                {{ $t("MemberFunction.Deposit.SelectDepositMethod") }}
              </option>
              <option
                class="text-black"
                v-for="(value, key) in PayType"
                :key="value + 'onlineDepositOther'"
                :value="key">
                {{ value }}
              </option>
            </select>
          </VField>
        </div>
      </label>
      <label
        for="StorePayment"
        class="grid grid-cols-12 text-[14px] md:text-[16px] mt-[16px] md:mt-[3dvh]"
        v-if="JSON.stringify(PayStorePayment) !== '{}'">
        <p class="mr-[1em] text-primary col-span-4"></p>
        <div class="relative col-span-8">
          <div class="h-[26px] w-full">
            <img
              v-img-src="triangle_icon"
              alt=""
              class="h-[12px] absolute right-[2.5%] md:right-[3.4%] top-[13px] -translate-y-1/2 z-20" />
          </div>
          <VField
            id="StorePayment"
            :label="$t('MemberFunction.Deposit.PaymentMethod')"
            name="StorePayment"
            v-slot="{ field }"
            class="relative"
            :rules="{ required: true }">
            <select
              v-bind="field"
              class="absolute select-bg-border top-0 bg-transparent px-2 rounded w-full h-[26px] text-primary">
              <option class="text-black" value="">
                {{ $t("MemberFunction.Deposit.SelectPayMethod") }}
              </option>
              <option
                class="text-black"
                v-for="(value, key) in PayStorePayment"
                :key="value + 'onlineDepositOther'"
                :value="key">
                {{ value }}
              </option>
            </select>
          </VField>
          <ErrorMessage
            name="StorePayment"
            class="text-primary text-[10px]"
            v-slot="{ message }">
            <p class="text-primary text-[10px] mr-[6px]">
              {{ message.includes("必填") ? "*必填" : message }}
            </p>
          </ErrorMessage>
        </div>
      </label>
      <label
        for="CVS"
        class="grid grid-cols-12 text-[14px] md:text-[16px] mt-[16px] md:mt-[3dvh]"
        v-if="JSON.stringify(PayCVS) !== '{}'">
        <p class="mr-[1em] text-primary col-span-4"></p>
        <div class="relative col-span-8">
          <div class="h-[26px] w-full">
            <img
              v-img-src="triangle_icon"
              alt=""
              class="h-[12px] absolute right-[2.5%] md:right-[3.4%] top-[13px] -translate-y-1/2 z-20" />
          </div>
          <VField
            id="CVS"
            :label="$t('MemberFunction.Deposit.PaymentMethod')"
            name="CVS"
            v-slot="{ field }"
            class="relative"
            :rules="{ required: true }">
            <select
              v-bind="field"
              class="absolute select-bg-border top-0 bg-transparent px-2 rounded w-full h-[26px] text-primary">
              <option class="text-black" value="">
                {{ $t("MemberFunction.Deposit.SelectPayMethod") }}
              </option>
              <option
                class="text-black"
                v-for="(value, key) in PayCVS"
                :key="value + 'onlineDepositOther'"
                :value="key">
                {{ value }}
              </option>
            </select>
          </VField>
          <ErrorMessage
            name="CVS"
            class="text-primary text-[10px]"
            v-slot="{ message }">
            <p class="text-primary text-[10px] mr-[6px]">
              {{
                message.includes("必填")
                  ? $t("MemberFunction.Deposit.Require")
                  : message
              }}
            </p>
          </ErrorMessage>
        </div>
      </label>
      <label
        for="BarcodePayment"
        class="grid grid-cols-12 text-[14px] md:text-[16px] mt-[16px] md:mt-[3dvh]"
        v-if="JSON.stringify(PayBarcodePayment) !== '{}'">
        <p class="mr-[1em] text-primary col-span-4"></p>
        <div class="relative inline-block col-span-8">
          <div class="h-[26px] w-full">
            <img
              v-img-src="triangle_icon"
              alt=""
              class="h-[12px] absolute right-[2.5%] md:right-[3.4%] top-[13px] -translate-y-1/2 z-20" />
          </div>

          <VField
            id="BarcodePayment"
            :label="$t('MemberFunction.Deposit.BarcodeMethod')"
            name="BarcodePayment"
            v-slot="{ field }"
            class="relative"
            :rules="{ required: true }">
            <select
              v-bind="field"
              class="absolute select-bg-border top-0 bg-transparent px-2 rounded w-full h-[26px] text-primary">
              <option class="text-black" value="">
                {{ $t("MemberFunction.Deposit.SelectPayMethod") }}
              </option>
              <option
                class="text-black"
                v-for="(value, key) in PayBarcodePayment"
                :key="value + 'onlineDepositOther'"
                :value="key">
                {{ value }}
              </option>
            </select>
          </VField>
          <ErrorMessage
            name="BarcodePayment"
            class="text-primary text-[10px]"
            v-slot="{ message }">
            <p class="text-primary text-[10px] mr-[6px]">
              {{
                message.includes("必填")
                  ? $t("MemberFunction.Deposit.Require")
                  : message
              }}
            </p>
          </ErrorMessage>
        </div>
      </label>
      <label
        for="TelecomPayment"
        class="grid grid-cols-12 text-[14px] md:text-[16px] mt-[16px] md:mt-[3dvh]"
        v-if="JSON.stringify(PayTelecomPayment) !== '{}'">
        <p class="mr-[1em] text-primary col-span-4"></p>
        <div class="relative inline-block col-span-8">
          <div class="h-[26px] w-full">
            <img
              v-img-src="triangle_icon"
              alt=""
              class="h-[12px] absolute right-[2.5%] md:right-[3.4%] top-[13px] -translate-y-1/2 z-20" />
          </div>
          <VField
            id="TelecomPayment"
            :label="$t('MemberFunction.Deposit.TelecomPayment')"
            name="TelecomPayment"
            v-slot="{ field }"
            class="relative"
            :rules="{ required: true }">
            <select
              v-bind="field"
              class="absolute select-bg-border top-0 bg-transparent px-2 rounded w-full h-[26px] text-primary">
              <option class="text-black" value="">
                {{ $t("MemberFunction.Deposit.SelectPayMethod") }}
              </option>
              <option
                class="text-black"
                v-for="(value, key) in PayTelecomPayment"
                :key="value + 'onlineDepositOther'"
                :value="key">
                {{ value }}
              </option>
            </select>
          </VField>
          <ErrorMessage
            name="TelecomPayment"
            class="text-primary text-[10px]"
            v-slot="{ message }">
            <p class="text-primary text-[10px] mr-[6px]">
              {{
                message.includes("必填")
                  ? $t("MemberFunction.Deposit.Require")
                  : message
              }}
            </p>
          </ErrorMessage>
        </div>
      </label>
      <label
        for="payCount"
        class="grid grid-cols-12 text-[14px] md:text-[16px] mt-[16px] md:mt-[3dvh]">
        <p class="mr-[1em] col-span-4">
          {{ $t("MemberFunction.Deposit.DepositAmount") }}
        </p>
        <div class="relative inline-block col-span-8">
          <div class="h-[26px]">
            <img v-img-src="文字框_長_A" alt="" class="h-[26px] w-full" />
          </div>
          <VField
            class="col-span-1 absolute h-[26px] top-0 rounded-md bg-transparent w-full px-2"
            id="payCount"
            :label="$t('MemberFunction.Deposit.DepositAmount')"
            name="payCount"
            type="number"
            min="1"
            :rules="{ required: true, min_value: 1 }" />
        </div>
      </label>
    </div>
    <div class="mt-[3dvh] md:static flex flex-col justify-center items-center">
      <button type="submit" class="btn-y-border">
        <p
          class="text-[14px] md:text-[14px] font-bold text-secondary px-[2em] py-[.1em]">
          {{ $t("MemberFunction.Deposit.Next") }}
        </p>
      </button>
      <div class="mt-[3dvh]">
        <div class="flex justify-center items-center leading-[36px]">
          <img v-img-src="驚嘆號icon" alt="" class="w-[16px] mr-1" />
          <span class="text-red-600">
            {{ $t("MemberFunction.Deposit.Notice") }}
          </span>
        </div>
        <div class="text-primary text-[14px] md:text-[16px] leading-[20px]">
          <div class="mb-[1vh] flex">
            <p class="text-red-600 mr-1">※</p>
            <p>
              {{ $t("MemberFunction.Deposit.OnlineNoticeList1") }}
            </p>
          </div>
          <div class="mb-[1vh] flex">
            <p class="text-red-600 mr-1">※</p>
            <p>{{ $t("MemberFunction.Deposit.OnlineNoticeList2") }}</p>
          </div>
          <div class="mb-[1vh] flex">
            <p class="text-red-600 mr-1">※</p>
            <p>
              {{ $t("MemberFunction.Deposit.OnlineNoticeList3") }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </VForm>
</template>
